import React from "react";
import classNames from "classnames";
import Typography from "antd/es/typography";

import styles from "../RecipientDetail.module.scss";

import { useProcessPayeeDetail } from "../useProcessPaymentDetail";

const InternationalContentExtend = (props: any) => {
  const { selectedPayee } = props;
  const {
    bankAccountHolderName,
    bankRawName,
    accountNumber,
    swiftCode,
    bsbCode,
    ifscCode,
    bankCode,
    aba,
    sortCode,
    iban,
    cnaps,
    stateOrProvince,
    address,
    city,
    postalCode,
    region,
    branchCode
  } = useProcessPayeeDetail(selectedPayee);

  return (
    <div>
      <div className={classNames(styles.row, styles.verticalRow)}>
        <span>Address</span>
        <Typography.Text ellipsis={true}>{address}</Typography.Text>
      </div>
      {city && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>City</span>
          <Typography.Text ellipsis={true}>{city}</Typography.Text>
        </div>
      )}
      {region && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>Region</span>
          <Typography.Text ellipsis={true}>{region}</Typography.Text>
        </div>
      )}
      {stateOrProvince && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>State/Province</span>
          <Typography.Text ellipsis={true}>{stateOrProvince}</Typography.Text>
        </div>
      )}
      {postalCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>Postal Code</span>
          <Typography.Text ellipsis={true}>{postalCode}</Typography.Text>
        </div>
      )}
      <div className={classNames(styles.row, styles.verticalRow)}>
        <span>Bank account holder name</span>
        <Typography.Text ellipsis={true}>
          {bankAccountHolderName}
        </Typography.Text>
      </div>
      <div className={classNames(styles.row, styles.verticalRow)}>
        <span>Bank</span>
        <Typography.Text ellipsis={true}>{bankRawName}</Typography.Text>
      </div>
      <div className={classNames(styles.row, styles.verticalRow)}>
        <span>Account number</span>
        <Typography.Text ellipsis={true}>{accountNumber}</Typography.Text>
      </div>
      <div className={classNames(styles.row, styles.verticalRow)}>
        <span>SWIFT code</span>
        <Typography.Text ellipsis={true}>{swiftCode}</Typography.Text>
      </div>
      {branchCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>Branch code</span>
          <Typography.Text ellipsis={true}>{branchCode}</Typography.Text>
        </div>
      )}
      {bsbCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>BSB code</span>
          <Typography.Text ellipsis={true}>{bsbCode}</Typography.Text>
        </div>
      )}
      {ifscCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>IFSC code</span>
          <Typography.Text ellipsis={true}>{ifscCode}</Typography.Text>
        </div>
      )}
      {bankCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>Bank code</span>
          <Typography.Text ellipsis={true}>{bankCode}</Typography.Text>
        </div>
      )}
      {aba && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>ABA/Routing Number</span>
          <Typography.Text ellipsis={true}>{aba}</Typography.Text>
        </div>
      )}
      {sortCode && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>Sort code</span>
          <Typography.Text ellipsis={true}>{sortCode}</Typography.Text>
        </div>
      )}
      {iban && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>IBAN</span>
          <Typography.Text ellipsis={true}>{iban}</Typography.Text>
        </div>
      )}
      {cnaps && (
        <div className={classNames(styles.row, styles.verticalRow)}>
          <span>CNAPS</span>
          <Typography.Text ellipsis={true}>{cnaps}</Typography.Text>
        </div>
      )}
    </div>
  );
};

export default InternationalContentExtend;
